export default {
  name: 'marking--codeType',
};